'use client';

import {modifyOutboundLink, QUERY_CONSTANTS, trackInitialReferral, trackLinkClick} from '@/lib/analyticsUtil';
import {useEffect} from 'react';

/**
 * Global Analytics Config
 *
 * Links: https://nextjs.org/docs/app/guides/third-party-libraries#google-tag-manager
 *
 * Handles initial page view tracking and link click tracking
 * @constructor
 */
export default function GlobalAnalytics() {


    /**
     * Track initial page view on component mount
     */
    useEffect(() => {
        // Track the initial page view when the app loads
        if (typeof window !== 'undefined') {
            trackInitialReferral();
        }
    }, []);

    /**
     * Link tracking setup
     */
    useEffect(() => {
        // Track initial referral on page load
        trackInitialReferral();

        const handleClick = (event: MouseEvent) => {
            // TODO: double check
            const target = event.target as HTMLElement;
            const link = target.closest('a');
            console.log('handleClick', event)
            if (!link) return;

            let href = link.getAttribute('href');
            if (!href) return;

            const ref = new URLSearchParams(window.location.search).get(QUERY_CONSTANTS.INBOUND_REF);
            const isOutbound = !href.startsWith('/') && !href.includes(window.location.hostname);

            if (isOutbound) {
                href = modifyOutboundLink(href, ref);
                link.setAttribute('href', href); // Update the href dynamically
            }

            trackLinkClick(href, isOutbound ? 'outbound' : 'inbound', ref);
        };

        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, []);

    return null
}
